import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import AuthenticationFactorList from 'Components/ComponentLibrary/Organisms/AuthenticationFactorList';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import { useWorkflowLayoutContext } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import { dataAttrs } from 'Helpers/Testing';
import { useCollectionStateContext } from 'Context/CollectionStateContext';
import { useRefreshAuthenticationFactors } from 'Hooks/useRefreshEvent';


const MFASetup = () => {
  const { setIsContentShowing } = useWorkflowLayoutContext();
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { refreshCollection } = useCollectionStateContext();

  // If this relationship exists that means the user still needs to enable MFA before proceeding. If not, they are
  // all set to continue forward
  const continueDisabled = resource.withRelationship(fr.relationships.onboardingMFARequired.name,
    (_) => true,
    () => false);

  useRefreshAuthenticationFactors(() => {
    refreshCollection();
  }, [refreshCollection]);

  React.useEffect(() => {
    setIsContentShowing(false);
  }, []);

  const authFactorContent = resource.withRelationship(fr.relationships.authenticationFactor.name, (rel) => {
    return (
      <AuthenticationFactorList
        authFactorsRelationship={rel}
        ListProps={{
          onMount: () => setIsContentShowing(true),
        }}
        hasUserSettingsRevampRelationship={resource.withRelationship(fr.relationships.userSettingsSecurityPageRevamp.name,
          (_) => true,
          () => false)}
      />
    );
  }, () => null);

  return (
    <FDStack direction={'column'} alignItems={'stretch'} spacing={2}>
      <MetaControlField
        attr={'title'}
        data-test={`user-auth-setup-title-${resource.type()}`}
      />
      <MetaControlField attr={'primaryText'} />
      {authFactorContent}
      <MetaControlField attr={'footnote'} />
      <MetaControlField attr={'alert'} />
      <FDStack direction={'column'} alignItems={'center'} spacing={2}>
        <FDPrimaryActionButton
          {...dataAttrs('user-auth-setup-mfa-continue-button')}
          disabled={continueDisabled}
          loading={saving}
          onClick={onSubmit}
          test={'user-auth-setup-mfa-continue-button'}
          label={'Continue'}
        />
      </FDStack>
    </FDStack>
  );
};

export { MFASetup };
